import { defineSlotRecipe } from '@chakra-ui/react';

export const footerSlotRecipe = defineSlotRecipe({
    slots: ['container', 'link', 'wrapper'],
    base: {
        wrapper: {
            bgColor: 'secondary.solid',
            color: 'white',
        },
        container: {
            maxWidth: 'containerWidth',
            px: 'gutterWidth',
            py: 6,
        },
        link: {
            color: 'white',
        },
    },
    variants: {
        size: {
            md: {
                container: {
                    px: 'gutterWidthDesktop',
                    py: 12,
                },
            },
        },
    },
});
